// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SimpleIntakeSiteModel {
    static getAttributeTypeMap() {
        return SimpleIntakeSiteModel.attributeTypeMap;
    }
}
SimpleIntakeSiteModel.discriminator = undefined;
SimpleIntakeSiteModel.additionalProperties = false;
SimpleIntakeSiteModel.attributeTypeMap = [
    {
        "name": "address",
        "baseName": "address",
        "type": "SimpleIntakeAddressModel"
    },
    {
        "name": "contact",
        "baseName": "contact",
        "type": "SimpleIntakeContactModel"
    },
    {
        "name": "id",
        "baseName": "id",
        "type": "number"
    },
    {
        "name": "name",
        "baseName": "name",
        "type": "string"
    },
    {
        "name": "npi",
        "baseName": "npi",
        "type": "string"
    },
    {
        "name": "taxId",
        "baseName": "taxId",
        "type": "string"
    },
    {
        "name": "type",
        "baseName": "type",
        "type": "RoleType"
    },
];
//# sourceMappingURL=simpleIntakeSiteModel.js.map